"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTimezonesQuery = exports.timezones = exports.timezonesAdapter = void 0;

var _toolkit = require("@reduxjs/toolkit");

var _EmptyAppApi = require("../../EmptyAppApi");

var timezonesAdapter = (0, _toolkit.createEntityAdapter)({
  selectId: function selectId(timezone) {
    return timezone.abbr;
  }
});
exports.timezonesAdapter = timezonesAdapter;

var timezones = _EmptyAppApi.emptyAppApi.injectEndpoints({
  endpoints: function endpoints(build) {
    return {
      getTimezones: build.query({
        query: function query(hashId) {
          return "/api/recipient/".concat(hashId, "/timezones");
        },
        transformResponse: function transformResponse(response) {
          return timezonesAdapter.addMany(timezonesAdapter.getInitialState(), response);
        }
      })
    };
  }
});

exports.timezones = timezones;
var useGetTimezonesQuery = timezones.useGetTimezonesQuery;
exports.useGetTimezonesQuery = useGetTimezonesQuery;